(function () {
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  function esc(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function t(key) {
    return (window.USHARE_GDD_I18N || {})[key] || "";
  }

  function readingMinutes(item) {
    var chunks = [item.t, item.b, item.html];
    (item.tk || []).forEach(function (x) {
      chunks.push(x);
    });
    (item.faqs || []).forEach(function (f) {
      chunks.push(f.q, f.a);
    });
    (item.src || []).forEach(function (s) {
      chunks.push(s.t);
    });
    var text = chunks
      .join(" ")
      .replace(/<[^>]+>/g, " ")
      .replace(/\s+/g, " ")
      .trim();
    if (!text) return 1;
    var cjk = (text.match(/[\u4e00-\u9fff]/g) || []).length;
    var rest = text
      .replace(/[\u4e00-\u9fff]/g, " ")
      .replace(/[^\w'-]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
    var words = rest ? rest.split(" ").length : 0;
    return Math.max(1, Math.round(cjk / 400 + words / 220) || 1);
  }

  function pageOverride() {
    var out = { handle: "", title: "", html: "", hasHtml: false, updated: "" };
    var el = document.getElementById("ushare-page-override");
    if (el) {
      try {
        var parsed = JSON.parse(el.textContent || "{}");
        out.handle = parsed.handle || "";
        out.title = parsed.title || "";
        out.html = parsed.html || "";
        out.hasHtml = Boolean(parsed.hasHtml);
        out.updated = parsed.updated || "";
      } catch (e) {}
    }
    var tpl = document.getElementById("ushare-page-html");
    if (tpl) {
      var html = (tpl.innerHTML || "").trim();
      if (html) {
        out.html = html;
        out.hasHtml = true;
      }
    }
    if (document.querySelector("[data-has-html]")) out.hasHtml = true;
    return out;
  }

  function textOf(node) {
    return String((node && node.textContent) || "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function sectionKind(text) {
    var s = String(text || "")
      .replace(/\s+/g, " ")
      .trim();
    if (/^key\s*takeaways?$|^takeaways?$|要点|puntos clave|à retenir|wichtigste punkte|ключевые выводы|النقاط الرئيسية|poin penting/i.test(s)) return "takeaways";
    if (/^faqs?$|^frequently asked questions?$|常见问题|preguntas frecuentes|questions fréquentes|häufige fragen|часто задаваемые|الأسئلة الشائعة|pertanyaan umum/i.test(s)) return "faq";
    if (/^sources?$|^references?$|^来源$|^参考文献$|^fuentes$|^quellen$|^источники$|^المصادر$|^sumber$/i.test(s)) return "sources";
    return "";
  }

  function splitKind(node) {
    if (!node || node.nodeType !== 1) return "";
    var kind = sectionKind(textOf(node));
    if (!kind) return "";
    if (/^H[1-4]$/.test(node.nodeName)) return kind;
    if (node.nodeName === "P" && textOf(node).length < 48) return kind;
    return "";
  }

  function nodesHtml(nodes) {
    var wrap = document.createElement("div");
    nodes.forEach(function (node) {
      wrap.appendChild(node.cloneNode(true));
    });
    return wrap.innerHTML.trim();
  }

  function parseFaqs(nodes) {
    var faqs = [];
    var q = "";
    var answers = [];
    function flush() {
      if (!q) return;
      faqs.push({ q: q, a: answers.join("\n\n") });
      q = "";
      answers = [];
    }
    nodes.forEach(function (node) {
      if (node.nodeType !== 1) {
        var stray = textOf(node);
        if (q && stray) answers.push(stray);
        return;
      }
      var heading = /^H[1-4]$/.test(node.nodeName);
      var boldOnly =
        node.nodeName === "P" &&
        node.querySelector("strong") &&
        textOf(node.querySelector("strong")) === textOf(node);
      if (heading || boldOnly) {
        flush();
        q = textOf(node);
        return;
      }
      var line = textOf(node);
      if (!line) return;
      if (!q) q = line;
      else answers.push(line);
    });
    flush();
    return faqs.filter(function (item) {
      return item.q;
    });
  }

  function parseSources(nodes) {
    var wrap = document.createElement("div");
    nodes.forEach(function (node) {
      wrap.appendChild(node.cloneNode(true));
    });
    var src = [];
    var links = wrap.querySelectorAll("a[href]");
    if (links.length) {
      Array.prototype.forEach.call(links, function (link) {
        src.push({
          t: textOf(link) || link.getAttribute("href"),
          u: link.getAttribute("href") || ""
        });
      });
      return src;
    }
    Array.prototype.forEach.call(wrap.querySelectorAll("li, p"), function (el) {
      var line = textOf(el);
      if (line) src.push({ t: line, u: "" });
    });
    return src;
  }

  function parseTakeaways(nodes) {
    var wrap = document.createElement("div");
    nodes.forEach(function (node) {
      wrap.appendChild(node.cloneNode(true));
    });
    var items = [];
    var lis = wrap.querySelectorAll("li");
    if (lis.length) {
      Array.prototype.forEach.call(lis, function (li) {
        var html = (li.innerHTML || "").trim();
        if (html) items.push(html);
      });
      return items;
    }
    Array.prototype.forEach.call(wrap.querySelectorAll("p"), function (p) {
      var html = (p.innerHTML || "").trim();
      if (html) items.push(html);
    });
    return items;
  }

  function nodesFromHtml(html) {
    var wrap = document.createElement("div");
    wrap.innerHTML = html || "";
    return Array.prototype.slice.call(wrap.childNodes);
  }

  function parsePageSections(html) {
    var source = html || "";
    var headingRe =
      /<(h[1-4]|p)(\s[^>]*)?>\s*(?:<(?:strong|b|span|em)[^>]*>\s*)*(Key Takeaways|Takeaways|要点|Puntos clave|À retenir|Wichtigste Punkte|Ключевые выводы|النقاط الرئيسية|Poin penting|FAQs?|Frequently Asked Questions|常见问题|Preguntas frecuentes|Questions fréquentes|Häufige Fragen|Часто задаваемые вопросы|الأسئلة الشائعة|Pertanyaan umum|Sources|References|来源|参考文献|Fuentes|Quellen|Источники|المصادر|Sumber)(?:\s*<\/(?:strong|b|span|em)>)*\s*<\/\1>/gi;
    var found = [];
    var match;
    while ((match = headingRe.exec(source))) {
      found.push({
        kind: sectionKind(match[3]),
        start: match.index,
        end: match.index + match[0].length
      });
    }
    var articleHtml = found.length ? source.slice(0, found[0].start) : source;
    articleHtml = articleHtml.replace(/<h2[^>]*>\s*Image Review\s*<\/h2>[\s\S]*$/i, "").trim();
    var buckets = { takeaways: "", faq: "", sources: "" };
    var seen = { takeaways: false, faq: false, sources: false };
    found.forEach(function (sec, i) {
      if (!sec.kind) return;
      seen[sec.kind] = true;
      var until = i + 1 < found.length ? found[i + 1].start : source.length;
      buckets[sec.kind] += source.slice(sec.end, until);
    });
    var articleText = articleHtml.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
    return {
      articleHtml: articleHtml,
      hasArticle: Boolean(articleText),
      tk: parseTakeaways(nodesFromHtml(buckets.takeaways)),
      hasTakeaways: seen.takeaways,
      faqs: parseFaqs(nodesFromHtml(buckets.faq)),
      hasFaq: seen.faq,
      src: parseSources(nodesFromHtml(buckets.sources)),
      hasSources: seen.sources
    };
  }

  function chevron() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 9 6 6 6-6"/></svg>';
  }

  function calSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 11h18"/></svg>';
  }

  function clockSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
  }

  function paras(text) {
    return String(text || "")
      .split(/\n{2,}/)
      .map(function (p) {
        return "<p>" + esc(p).replace(/\n/g, "<br>") + "</p>";
      })
      .join("");
  }

  ready(function () {
    if (typeof window.ushareApplyI18n === "function") window.ushareApplyI18n();
    var root = document.querySelector("[data-ushare-gdd]");
    if (!root) return;
    var slug = root.getAttribute("data-slug") || "";
    var items = window.USHARE_GDD || [];
    var catalog = window.USHARE_GUIDES || [];
    var cats = window.USHARE_GUIDE_CATS || [];
    var catTitles = {};
    cats.forEach(function (c) {
      catTitles[c.s] = c.t;
    });
    function catalogBySlug(s) {
      return catalog.filter(function (g) {
        return g.s === s || "guide-" + g.s === s;
      })[0];
    }
    function guideHref(g) {
      var loc = window.ushareUrl || String;
      if (g && g.url) return loc(g.url);
      var found = g && g.s ? catalogBySlug(g.s) : null;
      if (found && found.url) return loc(found.url);
      return g && g.s ? loc("/pages/" + g.s) : loc("/guides");
    }
    var page = pageOverride();
    var listed = catalogBySlug(slug);
    var item = items.filter(function (x) {
      return x.s === slug || "guide-" + x.s === slug;
    })[0];
    if (item) {
      if (page.title) item.t = page.title;
      if (page.hasHtml) {
        var parts = parsePageSections(page.html || "");
        if (parts.hasArticle) {
          item.html = parts.articleHtml;
          item.b = "";
        }
        if (parts.hasTakeaways) item.tk = parts.tk;
        if (parts.hasFaq) item.faqs = parts.faqs;
        if (parts.hasSources) item.src = parts.src;
      }
    } else if (page.title || page.hasHtml || listed) {
      item = {
        s: slug,
        t: page.title || (listed && listed.t) || "",
        b: (listed && listed.b) || "",
        html: page.html || "",
        tk: [],
        u: (listed && listed.u) || "",
        m: (listed && listed.m) || "",
        c: (listed && listed.c) || "",
        rv: "",
      };
    }
    if (item && listed) {
      if (!item.c) item.c = listed.c;
      if (!item.t) item.t = listed.t;
      if (!item.b && !page.hasHtml) item.b = listed.b || "";
    }
    var mount = root.querySelector("[data-gdd-root]");
    if (!item) {
      mount.innerHTML =
        '<div class="ushare-gdd-missing"><p>' +
        esc(t("missing")) +
        '</p><p><a href="' +
        (window.ushareUrl || String)("/guides") +
        '">' +
        esc(t("back")) +
        "</a></p></div>";
      return;
    }
    if (page.updated) item.u = page.updated;
    var stamp = root.getAttribute("data-updated");
    if (stamp) item.u = stamp;
    item.m = readingMinutes(item);

    document.title = item.t + " – Ushare";

    var take = "";
    if (item.tk && item.tk.length) {
      take =
        '<section class="ushare-gdd-take"><h2>' +
        esc(t("takeaways")) +
        "</h2><ul>" +
        item.tk
          .map(function (x) {
            return "<li>" + x + "</li>";
          })
          .join("") +
        "</ul></section>";
    }

    var rel = "";
    var related = item.rel && item.rel.length ? item.rel : [];
    if (!related.length && item.c) {
      related = catalog.filter(function (g) {
        return g.c === item.c && g.s !== slug;
      }).slice(0, 5);
    }
    if (item.rh || item.rt || related.length) {
      rel = '<section class="ushare-gdd-rel">';
      if (item.rh) rel += "<h2>" + esc(t("rel_hospitals")) + "</h2><p>" + esc(item.rh) + "</p>";
      if (item.rt) rel += "<h2>" + esc(t("rel_treatments")) + "</h2><p>" + esc(item.rt) + "</p>";
      if (related.length) {
        rel += "<h2>" + esc(t("rel_guides")) + "</h2><ul>";
        related.forEach(function (g) {
          if (g.s) {
            rel += '<li><a href="' + esc(guideHref(g)) + '">' + esc(g.t) + "</a></li>";
          } else {
            rel += "<li>" + esc(g.t) + "</li>";
          }
        });
        rel += "</ul>";
      }
      rel += "</section>";
    }

    var faq = "";
    if (item.faqs && item.faqs.length) {
      faq = '<section class="ushare-gdd-faq"><h2>' + esc(t("faq")) + "</h2>";
      item.faqs.forEach(function (f) {
        faq +=
          '<div class="ushare-gdd-acc"><button type="button">' +
          esc(f.q) +
          chevron() +
          '</button><div class="ushare-gdd-acc__body">' +
          paras(f.a) +
          "</div></div>";
      });
      faq += "</section>";
    }

    var src = "";
    if (item.src && item.src.length) {
      src = '<section class="ushare-gdd-src"><h2>' + esc(t("sources")) + "</h2><ol>";
      item.src.forEach(function (s) {
        if (s.u) {
          src +=
            "<li><a href=\"" +
            esc(s.u) +
            '" target="_blank" rel="noopener">' +
            esc(s.t) +
            "</a></li>";
        } else {
          src += "<li>" + esc(s.t) + "</li>";
        }
      });
      src += "</ol></section>";
    }

    mount.innerHTML =
      '<div class="ushare-gdd-wrap"><a class="ushare-gdd-back" href="' +
      (window.ushareUrl || String)("/guides") +
      '">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>' +
      esc(t("back")) +
      '</a><p class="ushare-gdd-cat">' +
      esc(catTitles[item.c] || "") +
      "</p><h1>" +
      esc(item.t) +
      '</h1><p class="ushare-gdd-lead">' +
      esc(item.b || "") +
      '</p><div class="ushare-gdd-meta"><span>' +
      calSvg() +
      esc((t("updated") || "Updated {{ date }}").replace("{{ date }}", item.u || "")) +
      "</span><span>" +
      clockSvg() +
      esc((t("read") || "{{ n }} min read").replace("{{ n }}", String(item.m || ""))) +
      "</span></div>" +
      (item.rv ? '<p class="ushare-gdd-rev">' + esc(item.rv) + "</p>" : "") +
      take +
      '<div class="ushare-gdd-body">' +
      (item.html || "") +
      "</div>" +
      rel +
      faq +
      src +
      "</div>";

    mount.addEventListener("click", function (e) {
      var btn = e.target.closest(".ushare-gdd-acc button");
      if (!btn) return;
      var acc = btn.parentElement;
      var open = acc.classList.contains("is-open");
      mount.querySelectorAll(".ushare-gdd-acc").forEach(function (el) {
        el.classList.remove("is-open");
      });
      if (!open) acc.classList.add("is-open");
    });
  });
})();
